import React, { useContext } from "react";
import useUserData from "../hooks/useUserData";

const UserDataContext = React.createContext();
export const UserDataProvider = ({ children }) => {
  const { isLoading, error, data, isError } = useUserData();

  return (
    <UserDataContext.Provider value={{ isLoading, isError, data, error }}>
      {children}
    </UserDataContext.Provider>
  );
};

export default function useUser() {
  const context = useContext(UserDataContext);
  return context;
}
